module.exports = __webpack_public_path__ + "static/media/ScreenTime_StyleGuide.4c5431a7.png";